<script setup lang="ts">
  import InlineSvg from 'vue-inline-svg';
  import type { SvgImageProps } from './SvgImage.types';

  withDefaults(defineProps<SvgImageProps>(), {
    fill: 'transparent',
    width: 24,
    height: 24,
  });

  defineOptions({
    inheritAttrs: false,
  });
</script>

<template>
  <InlineSvg
    :id="id"
    :data-testid="testId"
    :title="title"
    :src="image"
    :width="width"
    :height="height"
    :fill="fill"
    v-bind="$attrs"
  />
</template>
